import type { Check } from "../../api/check";
import { normalizeFailedCheckColor, type FailedCheckColor } from "../../utils/checkFormat";

export interface CheckFormValues {
  code: string;
  description: string;
  responsibility: string;
  successText: string;
  failText: string;
  suggestion: string;
  failedCheckColor: FailedCheckColor;
  active: boolean;
}

export const emptyCheckForm = (): CheckFormValues => ({
  code: "",
  description: "",
  responsibility: "",
  successText: "",
  failText: "",
  suggestion: "",
  failedCheckColor: "default",
  active: true,
});

export const checkToForm = (check: Check): CheckFormValues => ({
  code: check.code ?? "",
  description: check.description ?? "",
  responsibility: check.responsibility ?? "",
  successText: check.successText ?? "",
  failText: check.failText ?? "",
  suggestion: check.suggestion ?? "",
  failedCheckColor: normalizeFailedCheckColor(check.failedCheckColor),
  active: check.active !== false,
});

export const formToCheck = (form: CheckFormValues, id?: string): Check => ({
  ...(id ? { id } : {}),
  code: form.code.trim(),
  description: form.description.trim(),
  responsibility: form.responsibility.trim(),
  successText: form.successText.trim() || undefined,
  failText: form.failText.trim() || undefined,
  suggestion: form.suggestion.trim() || undefined,
  failedCheckColor: form.failedCheckColor,
  active: form.active,
});

export const validateCheckForm = (form: CheckFormValues): string | null => {
  if (!form.code.trim()) return "Укажите код проверки";
  if (!form.description.trim()) return "Укажите описание проверки";
  return null;
};
